import { setApiClient } from './index';

/**
 * Installs the client this environment should use.
 *
 * With an API configured, real resources are layered over the mock and the
 * simulated ones fall away step by step as the migration advances. Without one
 * — `vite dev`, or a container started without `API_BASE_URL` — it stays fully
 * simulated, so the app still runs with no backend at all.
 */
export async function installApi(): Promise<{ mode: 'http' | 'mock'; apiBaseUrl: string }> {
  const [{ createMockApi, getDataset }, { createHttpApi, readRuntimeConfig }] = await Promise.all([
    import('@/mock'),
    import('./http'),
  ]);

  const config = readRuntimeConfig();
  const mock = createMockApi(getDataset());

  if (config.backend === 'mock') {
    setApiClient(mock);
    return { mode: 'mock', apiBaseUrl: '' };
  }

  setApiClient(createHttpApi(mock, config));
  return { mode: 'http', apiBaseUrl: config.apiBaseUrl || 'mismo origen' };
}

/** Test/QA knobs (latency, forced failures). Also dynamic, same reason. */
export async function loadApiSimulation() {
  const { apiSimulation, configureApiSimulation, resetApiSimulation } = await import('@/mock');
  return { apiSimulation, configureApiSimulation, resetApiSimulation };
}
